import { ID, TicketMessage, TicketObjectType } from "@project/shared-types";
import { useEffect, useRef, useState } from "react";
import {
  GetMessagesByObjectIdAPI,
  SendMessageToTicketAPI,
} from "../api/SupportAPI";
import ArrowSvg from "../assets/taiga-uikit/icons/arrow-left-1.svg?react";
import CloseSvg from "../assets/taiga-uikit/icons/close.svg?react";
import SendSvg from "../assets/taiga-uikit/icons/send-2.svg?react";
import { Button } from "../components/button/button";
import { Divider } from "../components/Divider/Divider";
import { InputChat } from "../components/inputs/InputChat";
import { Text } from "../components/texts/text";
import { _colorText, _size, _sizeText, _style, _typeInput } from "../core/core";
import { SupportMessage } from "./SupportMessage";
import "./SupportTicket.css";

interface SupportTicketProps {
  on_click_back: () => void;
  on_click_close: () => void;
  object_type: TicketObjectType;
  object_id: ID;
  view_id: string;
  user_id: ID;
}

export const SupportTicket = ({
  on_click_back,
  on_click_close,
  object_type,
  object_id,
  view_id,
  user_id,
}: SupportTicketProps) => {
  const messageListRef = useRef<HTMLDivElement>(null);
  const [message, setMessage] = useState("");
  const [image, setImage] = useState(null);
  const [messages, setMessages] = useState<TicketMessage[]>([]);

  const handleKeyPress = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      await sendMessage();
    }
  };
  const onSendMessage = async () => {
    console.log(message);
    if (message.length <= 1) return;
    await sendMessage();
  };

  //Получение сообщений
  const fetchMessages = async () => {
    const response = await GetMessagesByObjectIdAPI({
      object_id,
      object_type,
    });
    if (response.messages) {
      setMessages(response.messages);
    }
  };
  const sendMessage = async () => {
    const response = await SendMessageToTicketAPI({
      messageText: message,
      object_id,
      object_type,
    });
    if (response.status === 200) {
      setMessage("");
      fetchMessages();
    }
  };
  useEffect(() => {
    fetchMessages();
  }, []);
  //Отправка сообщений
  return (
    <>
      <div className="messager-body">
        <div className="messager-header">
          <div className="messager-header-left">
            <Button
              size={_size.S}
              style={_style.flat}
              icon_left={<ArrowSvg />}
              onClick={on_click_back}
            />
            <div className="messager-header-main">
              <div className="messager-header-main-body">
                <Text size={_sizeText.mbold} color={_colorText.black}>
                  Помощь по{" "}
                  {object_type === TicketObjectType.ORDER ? "заказу" : "задаче"}{" "}
                  № {view_id}
                </Text>
              </div>
            </div>
          </div>
          <Button size={_size.M} style={_style.clear} onClick={on_click_close}>
            <CloseSvg />
          </Button>
        </div>
        <div className="messager-body-chat">
          <Divider style="gray" />
          <div ref={messageListRef} className="messager-scroll">
            {messages.length === 0 && (
              <div className="messager-list-empty">
                <Text size={_sizeText.m} color={_colorText.neutral}>
                  Пожалуйста, опишите вашу проблему, сообщений пока нет
                </Text>
              </div>
            )}
            <div className="messager-list">
              {messages.map((message) => (
                <SupportMessage
                  key={message.id}
                  message={message}
                  current_user_id={user_id}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="messager-footer">
          <Divider style="gray" />
          <div className="messager-footer-body">
            <InputChat
              focusStart
              onKeyDown={handleKeyPress}
              value={message}
              setValue={setMessage}
              placeholder="Написать сообщение..."
              type={_typeInput.message}
            />
            <Button
              onClick={onSendMessage}
              size={_size.M}
              style={_style.outline}
              icon_left={<SendSvg />}
            />
          </div>
        </div>
      </div>
    </>
  );
};
